<div class="col-md-4 sidebar">
    <div class="widget-main">
        <div class="widget-inner">
            <p class="login-form-hello">
                Willkommen {{ name }}!
            </p>
            <ul class="login-form-information margin-bottom">
                <li>
                    <fa-icon [icon]="['fas', 'angle-double-right']" class="list-icon"></fa-icon>
                    <a routerLink="/meinedaten" routerLinkActive="activeLoginLink">Meine Daten</a>
                </li>
                <li>
                    <fa-icon [icon]="['fas', 'angle-double-right']" class="list-icon"></fa-icon>
                    <a routerLink="/passwort-aendern" routerLinkActive="activeLoginLink">Passwort ändern</a>
                </li>
                <li>
                    <fa-icon [icon]="['fas', 'angle-double-right']" class="list-icon"></fa-icon>
                    <a routerLink="/zertifizierungsverlauf" routerLinkActive="activeLoginLink">Zertifizierungsverlauf</a>
                </li>
                <li>
                    <fa-icon [icon]="['fas', 'angle-double-right']" class="list-icon"></fa-icon>
                    <a routerLink="/" routerLinkActive="activeLoginLink" (click)="logout()">Logout</a>
                </li>
            </ul>
        </div>
    </div>
</div>
